import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgFacturen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FED27A"
      fillRule="evenodd"
      d="m18.2 6.63-5.35-.73-.76 5.52-2.78 20.24 17.83 2.45 2.78-20.24.38-2.77.38-2.75L18.2 6.64z"
      clipRule="evenodd"
    />
    <mask
      id="Facturen_svg__a"
      width={18}
      height={26}
      x={11}
      y={7}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M16.4 7H11v26h18V7z"
        clipRule="evenodd"
      />
    </mask>
    <g mask="url(#Facturen_svg__a)">
      <path
        fill="#FED27A"
        d="m-4.49 5.86 12.24 7.07L14.82.68z"
      />
      <path
        fill="#F7A941"
        d="M7.75 12.93.68 25.18 20 20zM5.86 44.49l7.07-12.24L.68 25.18zM25.18 39.32l7.07-12.25L20 20zM20 20l-7.07 12.25 12.25 7.07zM34.14-4.49 14.82.68l12.25 7.07zM39.32 14.82 27.07 7.75 20 20z"
      />
      <path
        fill="#F7A941"
        d="m5.86 44.49 19.32-5.17-12.25-7.07zM.68 25.18l12.25 7.07L20 20zM20 20l12.25 7.07 7.07-12.25z"
      />
      <path
        fill="#FED27A"
        d="m44.49 34.14-12.24-7.07-7.07 12.25z"
      />
      <path
        fill="#F7A941"
        d="m20 20 7.07-12.25L14.82.68zM14.82.68 7.75 12.93 20 20zM34.14-4.49 27.07 7.75l12.25 7.07z"
      />
    </g>
    <path
      fill="#fff"
      d="M20 10.5h-7v1h7zM21 13.5h-8v1h8zM20 16.5h-7v1h7zM27 16.51h-1.51V15h-1v1.51h-1.5v1h1.5v1.5h1v-1.5H27zM18.09 24.6c.61 0 1.19.24 1.63.67L21 24.18a4.16 4.16 0 0 0-2.91-1.17c-1.99 0-3.65 1.37-4.03 3.2h-1.07v1.6h1.07c.38 1.83 2.04 3.2 4.03 3.2 1.14 0 2.16-.45 2.91-1.17l-1.28-1.09c-.44.43-1.02.67-1.63.67-1.01 0-1.9-.66-2.22-1.6h2.39v-1.6h-2.39c.33-.94 1.21-1.6 2.22-1.6z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgFacturen);

export default ForwardRef;
